// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ExtraInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /implantacao/extra_incluir — um item só desta jornada (Full). Chamado NS 2026-0079. */
import { registerContract } from './validate'

export interface Implantacao_ExtraInput {
franquia_id?: number
etapa?: string
titulo?: string
descricao?: string
tipo?: string
responsavel?: string
obrigatorio?: boolean
}

registerContract('Implantacao_ExtraInput', {
  franquia_id: { type: 'number',  required: false },
  etapa:       { type: 'string',  required: false },
  titulo:      { type: 'string',  required: false },
  descricao:   { type: 'string',  required: false },
  tipo:        { type: 'string',  required: false },
  responsavel: { type: 'string',  required: false },
  obrigatorio: { type: 'boolean', required: false },
})
